// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__JpNvF","content":"Modal_content__irZCX"};